import blogsData from './blogs-data';

import blogImg1 from '../images/blog/screens/img-1.jpg';
import blogImg2 from '../images/blog/screens/img-2.jpg';
import blogImg3 from '../images/blog/screens/img-3.jpg';
import blogImg4 from '../images/blog/screens/img-4.jpg';
import blogImg5 from '../images/blog/screens/img-5.jpg';
import blogImg6 from '../images/blog/screens/img-6.jpg';

import blogAvaterImg1 from '../images/blog/blog-avater/img-1.jpeg';
import blogAvaterImg2 from '../images/blog/blog-avater/img-2.jpg';
import blogAvaterImg3 from '../images/blog/blog-avater/Author3.jpg';

import blogSingleImg1 from '../images/blog/blog1.jpg';
import blogSingleImg2 from '../images/blog/blog2.jpg';
import blogSingleImg3 from '../images/blog/blog3.jpg';
import blogSingleImg4 from '../images/blog/blog4.jpg';
import blogSingleImg5 from '../images/blog/blog5.jpg';
import blogSingleImg6 from '../images/blog/blog6.jpg';

const images = {
  1: {
    screens: blogImg1,
    authorImg: blogAvaterImg1,
    blogSingleImg: blogSingleImg1,
  },
  2: {
    screens: blogImg2,
    authorImg: blogAvaterImg1,
    blogSingleImg: blogSingleImg2,
  },
  3: {
    screens: blogImg3,
    authorImg: blogAvaterImg1,
    blogSingleImg: blogSingleImg3,
  },
  4: {
    screens: blogImg4,
    authorImg: blogAvaterImg2,
    blogSingleImg: blogSingleImg4,
  },
  5: {
    screens: blogImg5,
    authorImg: blogAvaterImg1,
    blogSingleImg: blogSingleImg5,
  },
  6: {
    screens: blogImg6,
    authorImg: blogAvaterImg3,
    blogSingleImg: blogSingleImg6,
  },
};

const blogs = blogsData.map((blog) => ({ ...blog, ...images[blog.id] }));

export default blogs;
